import { i as m, B as b, b as g, x as i, T as d, a as h } from "../separate-component-helper-chunks/abstract-base-0be59b32.js";
const f = m`*{margin:0}.summary-container{background-color:var(--beacon-color-background-default);border:2px solid var(--beacon-color-error-border)}.summary-header{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default));color:var(--beacon-color-text-default-on-light);margin-block-end:0;margin-block-start:var(--beacon-error-message-summary-header-space-margin);margin-inline:var(--beacon-error-message-summary-header-space-margin)}.error-list{list-style-position:inside;padding:0;margin-block-end:var(--beacon-error-message-summary-error-list-space-margin-surrounding);margin-block-start:var(--beacon-error-message-summary-error-list-space-margin-block-start);margin-inline:var(--beacon-error-message-summary-error-list-space-margin-surrounding)}.error-list li{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));color:var(--beacon-color-error-text)}.error-list li:not(:last-of-type){margin-block-end:var(--beacon-unit-atomic)}.error-list li a{color:inherit}
`;
var u = Object.defineProperty, v = Object.getOwnPropertyDescriptor, y = (o, r, s, a) => {
  for (var e = a > 1 ? void 0 : a ? v(r, s) : r, n = o.length - 1, t; n >= 0; n--)
    (t = o[n]) && (e = (a ? t(r, s, e) : t(e)) || e);
  return a && e && u(r, s, e), e;
};
const l = "beacon-error-message-summary";
class c extends b(g) {
  constructor() {
    super(...arguments), this.beaconTagName = l, this.errors = [];
  }
  static get styles() {
    return [super.styles, f];
  }
  render() {
    return i`${!this.errors || this.errors.length === 0 ? d : i`<section role="alert" class="summary-container">
          <p id="alertLabel" class="summary-header">
            There ${this.errors.length > 1 ? `are ${this.errors.length} errors` : `is ${this.errors.length} error`} in this form:
          </p>
          <ol class="error-list">
            ${this.errors.map(
      (r) => i`<li>
                  <a href="#${r.field}">${r.message}</a>
                </li>`
    )}
          </ol>
        </section>`}`;
  }
  connectedCallback() {
    var r;
    (r = this.handleDefer()) == null || r.then(() => {
      super.connectedCallback();
    });
  }
}
c.tagName = l;
y([
  h({ type: Array })
], c.prototype, "errors", 2);
export {
  c as BeaconErrorMessageSummary
};
